import React from 'react';
import {
  Avatar,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIconTypeMap,
  Theme,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { Box } from '@mui/system';
import { ColorPalette, TypographyFamily } from '../../styles/constants';
import { OverridableComponent } from '@mui/material/OverridableComponent';

const makeStyles = (theme: Theme) => ({
  listNavigation: {
    p: 0,
    color: ColorPalette.WHITE,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  listItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: 0,
    mb: 1,
  },
  listItemContent: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 1.5,
    width: 80,
    height: 80,
    p: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      width: 150,
      height: 75,
    },
  },
  selectedListItemContent: { backgroundColor: ColorPalette.COLUMBIA_BLUE },
  avatar: {
    width: 44,
    height: 44,
    backgroundColor: ColorPalette.COLUMBIA_BLUE,
    color: ColorPalette.DARK_GRAY,
    [theme.breakpoints.down('sm')]: {
      mr: 3,
    },
  },
  selectedAvatar: {
    backgroundColor: ColorPalette.MIDDLE_BLUE,
    color: ColorPalette.WHITE,
  },
  listItemIconCircle: {
    justifyContent: 'center',
  },
  listItemText: {
    fontFamily: TypographyFamily.NEXA,
    fontWeight: 700,
    textAlign: 'center',
    mt: 0.8,
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  selectedListItemText: {
    color: ColorPalette.RAISIN_BLACK,
  },
});

interface Props {
  isSelected: boolean;
  Icon: OverridableComponent<SvgIconTypeMap<Record<string, never>, 'svg'>>;
  label: string;
  url: string;
}

export function NavigationItem({
  isSelected,
  Icon,
  label,
  url,
}: Props): JSX.Element {
  const theme = useTheme();
  const style = makeStyles(theme);

  return (
    <ListItem button component={Link} to={url} sx={style.listItem}>
      <Box
        sx={{
          ...style.listItemContent,
          ...(isSelected && style.selectedListItemContent),
        }}
      >
        <ListItemIcon sx={style.listItemIconCircle}>
          <Avatar
            sx={{ ...style.avatar, ...(isSelected && style.selectedAvatar) }}
          >
            <Icon />
          </Avatar>
        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{
            ...style.listItemText,
            ...(isSelected && style.selectedListItemText),
          }}
          disableTypography
        />
      </Box>
    </ListItem>
  );
}
